import { QueryClient } from "@tanstack/react-query";

/**
 * Configuración de React Query pensada para una caja, no para un blog:
 *
 *  · `retry: 1` — si la red falla, un reintento y aviso. Reintentar tres veces
 *    con espera creciente deja al cajero mirando un spinner mientras hay
 *    clientes en la fila.
 *  · `refetchOnWindowFocus: false` — en una caja la ventana siempre tiene foco;
 *    recargar al enfocar provoca saltos innecesarios en pantalla.
 *  · `staleTime` de 30 s — el catálogo no cambia cada segundo.
 *  · Las mutaciones NO se reintentan solas: reintentar un cobro sin control es
 *    la forma más rápida de cobrar dos veces. Para eso está la Idempotency-Key
 *    (ADR-0007), que es una decisión explícita, no un reintento automático.
 */
export function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        retry: 1,
        staleTime: 30_000,
        refetchOnWindowFocus: false,
      },
      mutations: {
        retry: 0,
      },
    },
  });
}
